import { isDemoMode } from '../config/env';
import { DEMO_CREDENTIALS_HINT } from '../demo/demoData';
import { t } from '../i18n';
import './DemoBanner.css';

export function DemoBanner() {
  if (!isDemoMode) return null;

  return (
    <div className="demo-banner" role="status">
      <p className="demo-banner__short">
        <strong>{t('demo.short')}</strong>
      </p>
      <p className="demo-banner__full">
        {t('demo.full', {
          owner: DEMO_CREDENTIALS_HINT.owner,
          admin: DEMO_CREDENTIALS_HINT.admin,
          coach: DEMO_CREDENTIALS_HINT.coach,
          student: DEMO_CREDENTIALS_HINT.student,
        })}
      </p>
    </div>
  );
}
